var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.tag,{tag:"component",staticClass:"card-base-card-simple-rounded",class:{
        [`${_setup.theme}`]: !!_setup.theme,
        [`${_setup.type}`]: !!_setup.type,
    }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }